(function () {
  if (customElements.get('cart-discount-form')) return;

  function discountWasApplied(cart, code) {
    if (!cart) return false;
    var normalized = code.toLowerCase();
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length) {
      return cart.discount_codes.some(function (entry) {
        var entryCode = (entry.code || entry).toString().toLowerCase();
        return entryCode === normalized && entry.applicable !== false;
      });
    }
    if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) {
      return true;
    }
    return false;
  }

  function refreshCartSections() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var tasks = [];

    if (document.querySelector('cart-drawer-items')) {
      tasks.push(
        fetch(cartUrl + '?section_id=cart-drawer')
          .then(function (res) { return res.text(); })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
              var target = document.querySelector(selector);
              var source = html.querySelector(selector);
              if (target && source) target.replaceWith(source);
            });
          })
          .catch(function () {})
      );
    }

    var footerElement = document.getElementById('main-cart-footer');
    if (footerElement) {
      var sectionId = footerElement.dataset.id || 'main-cart-footer';
      tasks.push(
        fetch(cartUrl + '?section_id=' + sectionId)
          .then(function (res) { return res.text(); })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            var source = html.getElementById('main-cart-footer');
            var target = document.getElementById('main-cart-footer');
            if (target && source) target.replaceWith(source);
          })
          .catch(function () {})
      );
    }

    return Promise.all(tasks);
  }

  function showMessageOnAll(text, type) {
    document.querySelectorAll('[data-cart-discount-message]').forEach(function (el) {
      el.textContent = text;
      el.classList.remove('mm-cart-discount__message--success', 'mm-cart-discount__message--error');
      if (type) el.classList.add('mm-cart-discount__message--' + type);
    });
  }

  class CartDiscountForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-cart-discount-input]');
      this.button = this.querySelector('[data-cart-discount-apply]');
      this.button.addEventListener('click', this.onApply.bind(this));
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.onApply();
        }
      });
    }

    onApply() {
      const code = this.input.value.trim();
      if (!code) return;

      document.querySelectorAll('[data-cart-discount-apply]').forEach((el) => (el.disabled = true));
      showMessageOnAll('Aplicando cupom...', null);

      const body = JSON.stringify({ discount: code });

      fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig(), { body: body }))
        .then((res) => res.json())
        .then((cart) => {
          const applied = discountWasApplied(cart, code);
          return refreshCartSections().then(() => applied);
        })
        .then((applied) => {
          document.querySelectorAll('[data-cart-discount-input]').forEach((el) => (el.value = ''));
          showMessageOnAll(
            applied ? 'Cupom aplicado com sucesso!' : 'Cupom inválido, expirado ou não aplicável a este carrinho.',
            applied ? 'success' : 'error'
          );
        })
        .catch(() => {
          showMessageOnAll('Não foi possível aplicar o cupom agora. Tente novamente.', 'error');
        })
        .finally(() => {
          document.querySelectorAll('[data-cart-discount-apply]').forEach((el) => (el.disabled = false));
        });
    }
  }

  customElements.define('cart-discount-form', CartDiscountForm);
})();
